import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/hooks/useAuth';

export function ProtectedRoute() {
  const { isAuthenticated, loaded } = useAuth();
  const location = useLocation();

  if (!loaded) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <p className="text-sm text-muted">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
